import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const MoneyIllustration = ({ width = 51, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 45">
      <g fill="none" fillRule="evenodd">
        <path fill="#006474" d="M3.673 36.514L43.457 36.514 43.457 15.452 3.673 15.452z" />
        <path fill="#6AB3A9" d="M6.013 34.174L41.117 34.174 41.117 17.793 6.013 17.793z" />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M23.564 31.343c2.908 0 5.266-2.357 5.266-5.265 0-2.907-2.358-5.267-5.266-5.267s-5.266 2.36-5.266 5.267c0 2.909 2.358 5.265 5.266 5.265"
        />
        <path fill="#000" fillOpacity=".1" d="M23.564 36.514L43.457 36.514 43.457 15.452 23.564 15.452z" />
        <path
          fill="#FFBF00"
          d="M23.695 5.511c0 3.044-2.468 5.512-5.513 5.512-3.044 0-5.513-2.468-5.513-5.512 0-3.044 2.47-5.51 5.513-5.51 3.045 0 5.513 2.466 5.513 5.51"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M18.183 11.023V0c3.044 0 5.512 2.467 5.512 5.511 0 3.045-2.468 5.512-5.512 5.512"
        />
        <path
          fill="#FFBF00"
          d="M11.026 15.366c0 3.044-2.469 5.511-5.514 5.511C2.468 20.877 0 18.41 0 15.367c0-3.045 2.468-5.513 5.512-5.513 3.045 0 5.514 2.468 5.514 5.512"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M5.513 20.878V9.855c3.045 0 5.514 2.467 5.514 5.512 0 3.044-2.47 5.51-5.514 5.51"
        />
        <path
          fill="#FFBF00"
          d="M51 26.027c0 3.044-2.468 5.511-5.513 5.511-3.044 0-5.512-2.466-5.512-5.51 0-3.044 2.468-5.512 5.512-5.512 3.045 0 5.513 2.468 5.513 5.512"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M45.487 31.539V20.516c3.045 0 5.513 2.467 5.513 5.512 0 3.044-2.468 5.51-5.513 5.51"
        />
        <path
          fill="#FFBF00"
          d="M33.99 39.488c0 3.044-2.469 5.512-5.514 5.512-3.045 0-5.513-2.468-5.513-5.512 0-3.044 2.468-5.51 5.513-5.51s5.513 2.466 5.513 5.51"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M28.476 45V33.977c3.045 0 5.513 2.467 5.513 5.511 0 3.045-2.468 5.512-5.513 5.512"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
